import { useEffect, PropsWithChildren, useState } from 'react';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';
import Cookies from 'universal-cookie';

import {
  COOKIE_ADVERTISING,
  COOKIE_ANALYTICS,
  COOKIE_CONSENT,
  COOKIE_FUNCTIONAL,
} from 'constants/cookies';

import { CookieConsentContext } from '.';

const isCookieFlagEnabled = (cookies: Cookies, name: string) =>
  cookies.get(name, { doNotParse: true }) === '1';

const CookieConsentProvider = ({ children }: PropsWithChildren) => {
  const { trackEvent } = useAnalytics();

  const [cookieConsent] = useState(() => {
    const cookies = new Cookies();
    return {
      hasConsentCookie: isCookieFlagEnabled(cookies, COOKIE_CONSENT),
      functionalCookiesAccepted: isCookieFlagEnabled(cookies, COOKIE_FUNCTIONAL),
      analyticsCookiesAccepted: isCookieFlagEnabled(cookies, COOKIE_ANALYTICS),
      advertisingCookiesAccepted: isCookieFlagEnabled(cookies, COOKIE_ADVERTISING),
    };
  });

  useEffect(() => {
    trackEvent({
      event: 'gdpr_consent',
      gdpr: {
        marketing: cookieConsent.advertisingCookiesAccepted,
        analytics: cookieConsent.analyticsCookiesAccepted,
        functional: cookieConsent.functionalCookiesAccepted,
      },
    });
  }, [trackEvent, cookieConsent]);

  return (
    <CookieConsentContext.Provider value={cookieConsent}>{children}</CookieConsentContext.Provider>
  );
};

export default CookieConsentProvider;
